import { errorMonitor } from '../errorMonitor'

export const reportError = (error: Error, tags?: Record<string, string>) => {
  if (window.__DEBUG__ === 'true') {
    console.error(error)
  }
  errorMonitor.captureException(error, { tags })
}
